<script setup>
import Avatar from "primevue/avatar";
import Button from "primevue/button";
import {getInitials} from "../../../../../helpers.js";
import ReservationModal from "./ReservationModal.vue";
import {ref} from "vue";

defineProps({
    reservation: Object,
    unclickable: Boolean,
})

const visibleReservation = ref(false);
</script>

<template>
    <div @click="() => {
        if (!unclickable)
            {
                visibleReservation = true
            }
    }" class="border rounded-md shadow-sm bg-white flex flex-col hover:bg-gray-100 mb-2 transition-all dark:bg-gray-900 dark:hover:bg-gray-800 dark:border-neutral-700 hover:shadow cursor-pointer">
        <div class="flex gap-2 items-center p-3">
            <Avatar :label="getInitials(reservation.name)" shape="circle" class="!bg-blue-600 !text-white"></Avatar>
            <div class="grow">
                <p class="text-sm text-gray-500">
                    {{reservation.reservation_forms.name}}
                </p>
                <p class="font-semibold">
                    <span class="text-roori-blue">[</span>{{reservation.name}}<span class="text-roori-blue">]</span>
                </p>
            </div>
            <Button v-if="false" variant="outlined" icon="pi pi-check" rounded size="small" class="!w-9 !h-9"></Button>
            <Button v-if="false" variant="outlined" icon="pi pi-times" rounded size="small" class="!w-9 !h-9"></Button>
        </div>
    </div>
    <ReservationModal v-model:visible="visibleReservation" :reservation="reservation"></ReservationModal>
</template>

<style scoped lang="scss">

</style>
